import React, { useState, useEffect } from 'react';
import Button from '../Button/Button';
import styles from './Dashboard.module.css';
import send_fill from '../../assets/Send_fill.svg';
import search from '../../assets/Search_fill.svg';
import PopUpSend from '../PopUp/PopUpSend';
import PopUpConnexion from '../PopUp/PopUpConnexion';
import { GetDashboard } from '../../Services/demandes';
import LoadingIcon from '../LoadingIcon/LoadingIcon';
import { useNavigate } from 'react-router-dom'; // Importez useNavigate

function Dashboard({ isLoading }) {
  const navigate = useNavigate();
  const [isRequesting, setIsRequesting] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [prenom, setPrenom] = useState("");
  const [newDemands, setNewDemands] = useState("")
  const [enCours, setEncours] = useState("")
  const [traite, setTraite] = useState("")
  const [loading, setLoading] = useState(true)

  const handleCloseRequesting = () => {
    setIsRequesting(false);
  };

  const handleCloseSearching = () => {
    setIsSearching(false);
  };

  const handleDemandeClick = () => {
    setIsSearching(false);
    setIsRequesting(true);
  };

  const handleRechercheClick = () => {
    setIsRequesting(false);
    setIsSearching(true);
  };

  // const handleChangePage = (page) => {
  //   onPageChange(page);
  // };

  useEffect(() => {
    const getDashboardData = async () => {
      setLoading(true)

      isLoading(true)
      
      try {  
        const response = await GetDashboard(sessionStorage.getItem('currentMail'));

        if (!response.ok) {
            const messages = `An error has occurred: ${response.status}`;
            throw new Error(messages);
        }
        const data = await response.json();
        const result = JSON.parse(data);
        setPrenom(result.user.prenom);
        setNewDemands(result.dashboard.initial);
        setEncours(result.dashboard.enCours);
        setTraite(result.dashboard.traite);
        setTimeout(() => {
          isLoading(false); // Indique que le chargement est terminé
          setLoading(false)
        }, 700); 

      } catch (error) {
        console.error("Error saving response:", error);
        // Handle error display or other actions here
      }
  };

  getDashboardData();
}, []);

    return (
        <div className={styles.divContainer}>

          {!loading &&
            <div className={styles.contenu}>
              <h1 className={styles.titre}>Bonjour {prenom},</h1>
              <p className={styles.sousTitre}>Le résumé sur les demandes</p>

              <ul className={styles.resume}>
                <li className={styles.ligne}>
                  <span className={`${styles.icone} ${styles.iconeEnCours}`}>
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" />
                      <path d="M12 7v5l3 2" />
                    </svg>
                  </span>
                  <span className={styles.libelle}><strong>Demandes en cours</strong> de traitement</span>
                  <span className={styles.nombre}>{enCours}</span>
                </li>

                <li className={styles.ligne}>
                  <span className={`${styles.icone} ${styles.iconeNouvelles}`}>
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
                      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
                    </svg>
                  </span>
                  <span className={styles.libelle}><strong>Nouvelles demandes</strong> en attente</span>
                  <span className={styles.nombre}>{newDemands}</span>
                </li>

                <li className={styles.ligne}>
                  <span className={`${styles.icone} ${styles.iconeTraitees}`}>
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <path d="m22 4-10 10.01-3-3.01" />
                    </svg>
                  </span>
                  <span className={styles.libelle}><strong>Demandes traitées</strong> depuis votre dernière connexion</span>
                  <span className={styles.nombre}>{traite}</span>
                </li>
              </ul>

              <p className={styles.aide}>Vous pouvez modifier les filtres de recherche pour accéder à d’autres résultats.</p>
            </div>
          }
        </div>
    );

}

export default Dashboard;
